<template>
  <header class="header">
    <div class="container flex gap-50">
      <a href="#" @click.prevent="toHome" class="header__title">
        <img class="header__logo" src="/logo.png" alt="a.sk" />
      </a>
      <div class="header__auth">
        <GoogleButton v-if="!isAuth" variant="dark" label="Sign In" :width="200" />
        <div v-else class="header__user">
          <img
            v-if="user && user.picture"
            class="header__avatar"
            :src="user.picture"
            :alt="user.name"
            referrerpolicy="no-referrer"
          />
          <span class="header__name">{{ user && user.name }}</span>
          <button @click="signOut" type="button" class="header__signout">Sign out</button>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import { computed } from 'vue'
import store from '@/store'
import { googleSignOut } from '@/plugin/googleAuth'
import GoogleButton from '@/components/GoogleButton.vue'

export default {
  name: 'HeaderComponent',
  components: { GoogleButton },
  setup() {
    const isAuth = computed(() => store.getters.getAuthenticated)
    const user = computed(() => store.getters.getUser)

    function toHome() {
      window.location.href = '/'
    }
    function signOut() {
      googleSignOut()
      store.dispatch('signOutGoogle')
    }

    return { toHome, isAuth, user, signOut }
  },
}
</script>
<style scoped lang="scss">
.header { padding-top: 24px; margin-bottom: 60px; }
.header__title { display: inline-flex; align-items: center; text-decoration: none; }
.header__logo { display: block; height: 48px; width: auto; max-width: 220px; }
.header__auth { margin-left: auto; display: flex; align-items: center; min-height: 48px; }

.header__user { display: flex; align-items: center; gap: 12px; min-width: 0; }
.header__avatar {
  width: 40px; height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.5);
}
.header__name {
  color: #ffffff; font-size: 16px; font-weight: 500;
  max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.header__signout {
  flex-shrink: 0;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 18px;
  color: rgba(255, 255, 255, 0.9);
  padding: 8px 18px;
  font-size: 15px;
  cursor: pointer;
  transition: 0.3s color ease-in-out, 0.3s border-color ease-in-out;
}
.header__signout:hover { color: #ffffff; border-color: #ffffff; }

/* Phones: the logo + avatar + full name + Sign out is wider than the screen,
   which pushed "Sign out" off the right edge. Hide the name (the avatar shows
   who's signed in) and tighten spacing so everything fits. */
@media screen and (max-width: 560px) {
  .header { margin-bottom: 40px; }
  .container { gap: 16px; }
  .header__logo { height: 40px; }
  .header__name { display: none; }
  .header__user { gap: 10px; }
  .header__signout { padding: 8px 14px; font-size: 14px; }
}
</style>
